__webpack_require__.p = "https://jibaleysolution.fra1.cdn.digitaloceanspaces.com/magazana/test/";